import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs'; // Adjust the path based on your project structure

const Page: FC = () => {
  const { t: st } = useTranslation(['common'], { keyPrefix: 'policy' });
  const title = st('create_title');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.Document,
    parent: undefined,
    hrefRoot: '',
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Title-only object toolbar (CUS-166) — flag-gated. The create form keeps
      // its own Create/Cancel controls, so no save disc or actions here.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        activeTabId={'details'}
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Document}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
